import { cn } from '../../../utils'
import { BaseField, ValidationIcon } from '../base-field/BaseField'
import { Input } from './../base-field/input'
import styles from './TextField.module.css'
import { TextFieldProps } from './TextField.types'

function TextField(props: TextFieldProps) {
  const { ref, name, disabled, value, onChange, onFocus, onBlur, placeholder, ariaLabel, status, className, formFieldClass } = props

  return (
    <BaseField {...props} className={cn(styles.textField, className)} formFieldClass={formFieldClass}>
      <Input
        ref={ref}
        id={name}
        name={name}
        disabled={disabled}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={props.onClick}
        placeholder={placeholder}
        aria-label={ariaLabel}
        onKeyDown={props.onKeyDown}
        {...props.inputProps}
      />
      <ValidationIcon status={status ?? 'default'} />
      {props.iconRight ?? null}
    </BaseField>
  )
}

export default TextField
